import check from 'images/check.png';
import img from 'images/section-four.jpg';
import * as S from './styles';

function SectionFour() {
  return (
    <S.Wrapper>
      <S.Container>
        <img src={img} alt="" />
        <div>
          <h2>
            The World’s Largest
            <br />
            <span>Super Affiliate Community</span>
          </h2>
          <p className='desc'>
            Now is your chance to learn, network and grow with the{' '}
              <strong>biggest</strong> names in the affiliate marketing industry – behind
              closed doors.
          </p>
          <ul>
            
            <li>
              <img src={check} alt="" />
              <p>
                Get case studies, tutorials & video training worth{' '}
                <strong>$11,652+, yours FREE</strong> when you join
              </p>
            </li>
            <li>
              <img src={check} alt="" />
              <p>
                Feedback and help from 10+ expert moderators and thousands of
                affiliates
              </p>
            </li>
            <li>
              <img src={check} alt="" />
              <p>
                Exclusive STM-only access to{' '}
                <strong>tools, offers, landing pages & special industry reports</strong>
              </p>
            </li>
          </ul>
        </div>
        
      </S.Container>
    </S.Wrapper>
  );
}

export default SectionFour;
